import { useCallback } from "react";

import { useMutation } from "@apollo/client";

import { type StudyTreatmentInfo } from "../../gql-generated/types";
import {
    type BatchUpdateAbExposureMutation,
    type BatchUpdateAbExposureMutationVariables,
    batchUpdateAbExposure,
} from "../api";
import { abExposureLoggingStore } from "../models";

export type UpdateAbExposureOutput = (studyTreatmentInfo: StudyTreatmentInfo) => Promise<void>;

export const useLogAbExposure = (): UpdateAbExposureOutput => {
    const [sendExposure] = useMutation<BatchUpdateAbExposureMutation, BatchUpdateAbExposureMutationVariables>(
        batchUpdateAbExposure,
    );

    return useCallback(
        async (studyTreatmentInfo: StudyTreatmentInfo) => {
            if (!abExposureLoggingStore.hasItem(studyTreatmentInfo)) {
                await sendExposure({
                    variables: {
                        studyTreatmentInfo,
                    },
                });

                abExposureLoggingStore.setItem(studyTreatmentInfo);
            }
        },
        [sendExposure],
    );
};
